import { Assertions } from '~/packages/variable/variables.typing'
import object, { ShapeBase } from '../object'

// @TODO: Implement assertions type
export const assertions = object<Assertions & ShapeBase>({} as Assertions & ShapeBase)
